import {cardTitle} from "assets/jss/material-dashboard-pro-react.jsx";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const modelosStyle = {
  ...customCheckboxRadioSwitch,
  cardTitle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    "& small": {
      fontSize: "80%",
      fontWeight: "400"
    },
    textTransform: "capitalize"
  },
  cardCategory: {
    marginTop: "10px",
    color: "#999999 !important",
    textAlign: "center"
  },
  description: {
    color: "#999999"
  },
  updateProfileButton: {
    float: "right"
  },
  modelosContainer: {
    "&> div > div > h2": {
      padding: "0",
      margin: "0"
    }
  },
  modalCardTitle: {
    fontSize: "23px",
    position: "relative",
    top: "5px",
    left: "10px"
  },
  addStuffButton: {
    padding: "5px 12px 5px 10px!important",
    marginLeft: "10px!important"
  },
  searchInput: {
    paddingTop: 0,
    marginTop: 0
  },
  addModeloButton: {
    padding: "5px 12px 5px 10px!important",
    marginLeft: "10px!important"
  },
  buttonConfirm: {
    width: "150px"
  },
  ...buttonStyle,
  ...customSelectStyle,
  selectMenu: {
    zIndex: 9000
  },
  datetime: {
    margin: "15px 0"
  },
  addForm: {
    padding: "0 10px"
  },
  moduloCard: {
    marginTop: 0
  },
  moduloCardBody: {
    padding: "0px 10px 10px",
    "&> label": {
      display: "block",
      color: "#e8e8e8",
      "&> span": {
        color: "white",
        position: "absolute",
        right: "20px"
      }
    },
    "& table": {
      width: "100%"
    }
  },
  innerCardTitle: {
    fontSize: "16px",
    fontWeight: "bolder",
    color: "#e6e6e6",
    float: "left",
    width: "calc(100% - 20px)"
  },
  innerCardTitleButton: {
    /*  float: "right",
      paddingTop: "0",
      paddingRight: "0"*/
  },
  deleteAreaButton: {
    width: "30px",
    maxWidth: "30px",
    margin: 0,
    padding: 0,
    height: 30,
    minWidth: 0,
    float: "right"
  },
  editAreaButton: {
    width: "30px",
    maxWidth: "30px",
    margin: 0,
    padding: 0,
    height: 30,
    minWidth: 0,
    float: "right",
    color: "#f78200",
    "&:hover, &:focus": {
      color: "#ef7c00"
    }
  },
  areaContentGrid: {
    marginBottom: "-20px"
  },
  addModuloButton: {
    width: "60px",
    minHeight: "0",
    height: "60px",
    boxShadow: "0px 0px 9px 0px #00000054",
    "&:focus,&:hover": {
      boxShadow: "0px 0px 9px 0px #00000054",
    },
    borderRadius: "50%",
    display: "block",
    margin: "10px auto",
    marginBottom: "24px",
    "&> span": {
      "&> svg": {
        height: "65%",
        width: "90%",
        marginTop: "5px"
      }
    }
  }
};

export default modelosStyle;
